import { endpoints } from './endpoints'

/**
 * Configuracoes globais da API.
 * Define URLs, timeouts e configuracoes especificas para cada ambiente.
 */

// Gera array de rotas publicas baseado nas configuracoes dos endpoints
const rotasPublicas = Object.entries(endpoints)
    .filter(([_, config]) => config.publico)
    .map(([_, config]) => config.url)

/**
 * Validacao do ambiente atual.
 * Garante que apenas ambientes validos sejam utilizados.
 */
const ambientesValidos = ['development', 'homologation', 'production']
const ambienteAtual = import.meta.env.MODE || 'development'

if (!ambientesValidos.includes(ambienteAtual)) {
    throw new Error(`Ambiente '${ambienteAtual}' nao e valido`)
}

const urlsPorAmbiente = {
    development: 'http://127.0.0.1:8000',
    // development: 'https://testapi.processtouse.com/',
    homologation: 'https://homolog.api.processtouse.com/',
    production: 'https://api.processtouse.com/',
}

/**
 * Configuracao principal da API.
 * Exporta objeto com todas as configuracoes necessarias.
 */
export const API_CONFIG = {
    ambiente: ambienteAtual,
    urls: urlsPorAmbiente,
    baseUrl: import.meta.env.VITE_API_URL || urlsPorAmbiente[ambienteAtual],
    timeout: 30000,
    rotasPublicas,
    headers: {
        development: {
            'X-Environment': 'dev',
        },
        homologation: {
            'X-Environment': 'homolog',
        },
        production: {
            'X-Environment': 'prod',
        },
    },
}
